module.exports = __webpack_public_path__ + "img/check-icon-grey.5db6eb67.svg";